import React, { Component } from 'react';
import { FormattedMessage } from "react-intl";
import { BaseCombobox } from '../controls/BaseCombobox';
import { ProductBrandTemplate, ProductCategory, ProductOptionCategory } from '../infrastructure/AppConstants';

export class OptionCategorySelect extends Component {
    constructor(props) {
        super(props);

        this.handleValueSeleted = this.handleValueSeleted.bind(this);
    }

    handleValueSeleted(e) {
        var handler = this.props.onValueSeleted;
        if (handler) {
            handler(parseInt(e.target.value));
        }
    }

    changeOptions() {
        const { orderTemplate, productCategory } = this.props;
        if (orderTemplate == ProductBrandTemplate.WSA && productCategory == ProductCategory.CustomMade) {
            return [
                { value: ProductOptionCategory.CustomizedMachineModel, text: "CustomizedMachineModel" },
                { value: ProductOptionCategory.Attachment, text: "Attachment" },
                { value: ProductOptionCategory.AntiEarwaxDevice, text: "AntiEarwaxDevice" },
                { value: ProductOptionCategory.Vent, text: "Vent" },
                { value: ProductOptionCategory.OnlyForRICSeries, text: "OnlyForRICSeries" },
                { value: ProductOptionCategory.OtherOptions, text: "OtherOptions" },
                { value: ProductOptionCategory.Cord, text: "Cord" },
                { value: ProductOptionCategory.ShellCoating, text: "ShellCoating" },
                { value: ProductOptionCategory.EnclosureImage, text: "EnclosureImage" },
                { value: ProductOptionCategory.EnclosureColor, text: "EnclosureColor" }
            ];
        }
        else if (orderTemplate == ProductBrandTemplate.WSA && productCategory == ProductCategory.Eardrum) {
            return [
                { value: ProductOptionCategory.EardrumBte, text: "EardrumBte" },
                { value: ProductOptionCategory.EardrumRic, text: "EardrumRic" },
                { value: ProductOptionCategory.EardrumMaterialColor, text: "EardrumMaterialColor" },
                { value: ProductOptionCategory.EardrumBteVent, text: "EardrumBteVent" },
                { value: ProductOptionCategory.EarmoldBteTubeDiameter, text: "EarmoldBteTubeDiamete" },
                { value: ProductOptionCategory.EarmoldBteTubeLength, text: "EarmoldBteTubeLength" },
                { value: ProductOptionCategory.EarmoldBteLength, text: "EarmoldBteLength" },
                { value: ProductOptionCategory.EarmoldRicReceiverVersion, text: "EarmoldRicReceiverType" },
                { value: ProductOptionCategory.EardrumRicVent, text: "EardrumRicVent" },
                { value: ProductOptionCategory.EardrumRicCordLength, text: "EardrumRicCordLength" },
                { value: ProductOptionCategory.EardrumRicReceiver, text: "EarmoldRicReceiverGain" },
                { value: ProductOptionCategory.EardrumRicCord, text: "EardrumRicCord" },
                { value: ProductOptionCategory.EardrumCategory, text: "EardrumCategory" },
                { value: ProductOptionCategory.EardrumVersion, text: "EardrumVersion" },
               
            ];
        }
        else if (orderTemplate == ProductBrandTemplate.Widex && productCategory == ProductCategory.CustomMade) {
            return [
                { value: ProductOptionCategory.WidexSeries, text: "CustomeMadeType" },
                { value: ProductOptionCategory.MadeStyle, text: "MadeStyle" },
                { value: ProductOptionCategory.OtherMade, text: "OtherMadeOption" },
                { value: ProductOptionCategory.Spiracle, text: "SpiracleType" },
                { value: ProductOptionCategory.SpiracleSize, text: "ChooseSpiracleSize" },
            ];
        }
        else if (orderTemplate == ProductBrandTemplate.Widex && productCategory == ProductCategory.Eardrum) {
            return [
                { value: ProductOptionCategory.BTEEardrumMaterial, text: "ConventionalEarBackMachineEardrumMaterial" },
                { value: ProductOptionCategory.BTEEardrumStyle, text: "ConventionalEarBackMachineEardrumStyle" },
                { value: ProductOptionCategory.BTEEarphoneDiameter, text: "AcousticTubeDiameter" },
                { value: ProductOptionCategory.BTEEarphoneSize, text: "SoundTubeLength" },
                { value: ProductOptionCategory.BTEEarphoneStyle, text: "SlimTubeMachineEarplugsStyle" },
                { value: ProductOptionCategory.ReceiverMaterial, text: "CustomExternalReceiversMaterial" },
                { value: ProductOptionCategory.ReceiverStyle, text: "CustomExternalReceiversStyle" },
                { value: ProductOptionCategory.SoundOutletType, text: "SoundOutletType" },
                { value: ProductOptionCategory.ReceiverPower, text: "ReceiverPower" },
                { value: ProductOptionCategory.EarHookSize, text: "EarHookLength" },
                { value: ProductOptionCategory.EardrumOtherMade, text: "OtherMadeOption" },
                { value: ProductOptionCategory.EardrumSpiracle, text: "SpiracleType" },
                { value: ProductOptionCategory.EardrumSpiracleSize, text: "ChooseSpiracleSize" },
            ];
        }

        return [];
    }

    render() {
        let options = this.changeOptions();
        return (
            <BaseCombobox onChangeCapture={this.handleValueSeleted}>
                    <FormattedMessage id="PickOne" >
                        {text => <option value="-1">{text}</option>}
                    </FormattedMessage>
                    {options.map(o =>
                        <FormattedMessage key={ o.value} id={o.text}>
                            {displayText => <option key={o.value} value={o.value}>{displayText}</option>}
                    </FormattedMessage>)}                                        
            </BaseCombobox>
        );
    }
}



